export const FREE_TRIAL_FAQ_URL = "https://www.syskit.com/_app-links/subscriptions/faq/"